import { render } from "./WeekDays.vue?vue&type=template&id=db6ce018&scoped=true"
import script from "./WeekDays.vue?vue&type=script&lang=js"
export * from "./WeekDays.vue?vue&type=script&lang=js"

import "./WeekDays.vue?vue&type=style&index=0&id=db6ce018&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db6ce018"]])

export default __exports__